module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('v-row', [_c('v-dialog', {
    attrs: {
      "content-class": "all-dialog-wrapper",
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-row', {
    staticClass: "close-button"
  }, [_c('v-col', [_c('img', {
    staticClass: "closse-icon-modal",
    attrs: {
      "src": "/static/img/closse.svg"
    },
    on: {
      "click": _vm.closse
    }
  })])], 1), _vm._v(" "), (!_vm.isComplite) ? [_c('v-form', {
    staticClass: "wrapper-modal"
  }, [_c('v-row', {
    staticClass: "title-text"
  }, [_c('v-col', [_vm._v("\n              ОТПРАВИТЬ ЗАЯВКУ \n            ")])], 1), _vm._v(" "), [(!_vm.getUser) ? _c('v-row', {
    staticClass: "input-row"
  }, [_c('v-col', [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.nameErrors,
      "required": "",
      "color": "grey",
      "label": "Имя"
    },
    on: {
      "input": function($event) {
        return _vm.$v.select.name.$touch()
      },
      "blur": function($event) {
        return _vm.$v.select.name.$touch()
      }
    },
    model: {
      value: (_vm.select.name),
      callback: function($$v) {
        _vm.$set(_vm.select, "name", $$v)
      },
      expression: "select.name"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.getUser) ? _c('v-row', {
    staticClass: "input-row"
  }, [_c('v-col', [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.emailErrors,
      "required": "",
      "color": "grey",
      "label": "Email"
    },
    on: {
      "input": function($event) {
        return _vm.$v.select.email.$touch()
      },
      "blur": function($event) {
        return _vm.$v.select.email.$touch()
      }
    },
    model: {
      value: (_vm.select.email),
      callback: function($$v) {
        _vm.$set(_vm.select, "email", $$v)
      },
      expression: "select.email"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.getUser) ? _c('v-row', {
    staticClass: "input-row"
  }, [_c('v-col', [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('+7(###)-###-##-##'),
      expression: "'+7(###)-###-##-##'"
    }],
    attrs: {
      "error-messages": _vm.phoneErrors,
      "required": "",
      "placeholder": "+7(###)-###-##-##",
      "color": "grey",
      "label": "Номер телефона"
    },
    on: {
      "input": function($event) {
        return _vm.$v.select.phone.$touch()
      },
      "blur": function($event) {
        return _vm.$v.select.phone.$touch()
      }
    },
    model: {
      value: (_vm.select.phone),
      callback: function($$v) {
        _vm.$set(_vm.select, "phone", $$v)
      },
      expression: "select.phone"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-textarea', {
    attrs: {
      "error-messages": _vm.textErrors,
      "required": "",
      "outlined": "",
      "content-class": "elevation-0",
      "label": "Введите сообщение..."
    },
    on: {
      "input": function($event) {
        return _vm.$v.select.text.$touch()
      },
      "blur": function($event) {
        return _vm.$v.select.text.$touch()
      }
    },
    model: {
      value: (_vm.select.text),
      callback: function($$v) {
        _vm.$set(_vm.select, "text", $$v)
      },
      expression: "select.text"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "text-obr row-dowload-button"
  }, [_c('v-col', {
    attrs: {
      "cols-md": "8"
    }
  }, [_vm._v("\n                  Прикрепить файл\n                ")]), _vm._v(" "), _c('v-col', [_c('input', {
    ref: "filePasport",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grey-button",
    on: {
      "click": function($event) {
        return _vm.$refs.filePasport.click()
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.select.file ? _vm.select.file.name : 'Загрузить') + " "), _c('img', {
    attrs: {
      "src": "/static/img/dowload_icon.svg"
    }
  })])])], 1)], _vm._v(" "), _c('v-row', {
    staticClass: "row-button"
  }, [_c('v-col', [_c('ui_btn', {
    attrs: {
      "type": "main-btn full-width"
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v("Отправить заявку")])], 1)], 1)], 2)] : _vm._e(), _vm._v(" "), (_vm.isComplite) ? [_c('div', [_c('v-row', {
    staticClass: "img-complite-row"
  }, [_c('v-col', {
    staticStyle: {
      "text-align": "-webkit-center"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/regComplited.svg"
    }
  })])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "title-text"
  }, [_c('v-col', [_vm._v("\n                ОБРАЩЕНИЕ ОТПРАВЛЕНО АДВОКАТУ\n              ")])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "text-complite-reg"
  }, [_c('v-col', [_vm._v("\n                Вы можете просмотреть его в личном кабинете в разделе обращения. В случае, если вы еще не зарегистрированы, вы можете выполнить вход по номеру телефона, для просмотра заявки.\n              ")])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "text-complite-reg"
  }, [_c('v-col', [_vm._v("\n                или вернуться к поиску адвокатов \n              ")])], 1)], 1)] : _vm._e()], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2be36ee1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/ticketCreate/create.vue
// module id = 347
// module chunks = 2